export interface MathfieldKeyboardOptions {
  mathField: HTMLElement;
  keyboard: {
    show(): void;
    hide(): void;
  };
  isOpen: () => boolean;
  setOpen: (v: boolean) => void;
  //updateLayout: () => void;
  pageContainerSelector?: string;  // defaults to '.page-container'
  pageOriginalHeight: string;
}
// Global state to track keyboard status across all mathfields
let globalKeyboardState = {
  isOpen: false,
  currentMathField: null as HTMLElement | null,
  closeButton: null as HTMLElement | null
};

export function attachMathfieldKeyboardListeners(opts: MathfieldKeyboardOptions) {
  const sel = opts.pageContainerSelector || '.page-container';

  if (opts.mathField.shadowRoot) {
    opts.mathField.shadowRoot.addEventListener('click', (e) => {
      
        const target = e.target as HTMLElement;
        const toggleButton = target.closest('[part="virtual-keyboard-toggle"]');
        
        if (toggleButton) {
          // e.preventDefault();
          // e.stopPropagation();
          
          // console.log('Toggle clicked. Current global state:', globalKeyboardState.isOpen);
          
          // Always close if keyboard is open, regardless of which mathfield
          setTimeout(() => {
          if (globalKeyboardState.isOpen) {
            closeVirtualKeyboard(opts);
          } else {
            // Open keyboard for this mathfield
            openVirtualKeyboard(opts);
          }
        }, 300);

        }
      
    });
  }
  
  // Blur handler - only close if no other mathfield has focus
  opts.mathField.addEventListener('blur', (e: FocusEvent) => {
    setTimeout(() => {
      // Check if focus moved to another math-field
      const activeElement = document.activeElement;
      const isMathFieldFocused = activeElement?.tagName.toLowerCase() === 'math-field';
      
      // console.log('Blur event. Active element:', activeElement?.tagName, 'Is mathfield focused:', isMathFieldFocused);
      
      if (!isMathFieldFocused && globalKeyboardState.isOpen) {
        closeVirtualKeyboard(opts);
      }
    }, 300);
  });
}

export function openVirtualKeyboard(opts: MathfieldKeyboardOptions) {
  const sel = opts.pageContainerSelector || '.page-container';

  // If keyboard is already open for another mathfield, close it first
  if (globalKeyboardState.isOpen && globalKeyboardState.currentMathField !== opts.mathField) {
    const currentOpts = { ...opts, mathField: globalKeyboardState.currentMathField! };
    closeVirtualKeyboard(currentOpts, false); // Don't update global state yet
  }
  
  // console.log("Opening keyboard for mathfield");
  
  // Update global state
  globalKeyboardState.isOpen = true;
  globalKeyboardState.currentMathField = opts.mathField;
  
  opts.setOpen(true);
  opts.mathField.focus();
  
  // console.log("UPDATING KEYBOARD")
  updateMathFieldKeyboard(opts);
  // Update page container height
  const pageContainer = document.querySelector(sel) as HTMLElement;
  if (pageContainer) {
    const originalHeight = opts.pageOriginalHeight || pageContainer.style.height;
    
    if (originalHeight && originalHeight !== '') {
      pageContainer.style.height = `calc(${originalHeight} - 272px)`;
    } else {
      pageContainer.style.height = 'calc(100% - 272px)';
    }
  }
  
  // Hide all mathfield toggle buttons and menu toggles// DISABLE THE MENU IN ALL MATHS FIELDS
  // This patch is being added here because this is the most stable control of opening and closing of the keyboard so far
  // There is a huge bug with how math-field handles their popups. it is done in "presentation layers".
  // It seems that when one presentation layer is open while another is still open, the code breaks for the new presentation layey we are trying to open.
  // In this case, when you click and hold a sign key plus, minus, times, etc on the keyboard, a popup shows, they call it "key variants"
  // This key variant panel does not auto-dismiss when you click outside. you have to pick an option. They commented on it on line 21958, mathlive.js
  // when a key variant panel is open and you tru to open any mathfield menu (the hamburger menu in the input field), the code handling it breaks
  // and asides the UI getting distorted, which can be dismissed but is not intuitive for our type of users, you will not be able to open that menu again for that mathfield unless it is reinitialized, i.e a reload.
  // The best solution i have come up with is to turn off all mathfield toggle button available on the page when the keyboard is open. and restore when the keyboard is closed. 
  disableAllMathFieldControls();

}

export function closeVirtualKeyboard(opts: MathfieldKeyboardOptions, updateGlobalState: boolean = true) {
  // console.log("Closing keyboard");
  
  restoreHeight(opts);
  enableAllMathFieldControls();
  // removeCustomCloseButton();
  
  if (updateGlobalState) {
    globalKeyboardState.isOpen = false;
    globalKeyboardState.currentMathField = null;
  }
  
  opts.keyboard.hide();
  opts.setOpen(false);
}

function disableAllMathFieldControls() {
  const mathFields = document.querySelectorAll('math-field');
  mathFields.forEach((field: any) => {
    // field.setAttribute('style', 'border: none; pointer-events: none; background: transparent;');
    // Hide virtual keyboard toggle
    const keyboardToggle = field.shadowRoot?.querySelector('[part="virtual-keyboard-toggle"]') as HTMLElement;
    if (keyboardToggle) {
      keyboardToggle.setAttribute('data-original-style', keyboardToggle.getAttribute('style') || '');
      keyboardToggle.setAttribute('style', 'visibility: hidden;pointer-events: none;');
    }
    
    // Hide menu toggle
    const menuToggle = field.shadowRoot?.querySelector('[part="menu-toggle"]') as HTMLElement;
    if (menuToggle) {
      menuToggle.setAttribute('data-original-style', menuToggle.getAttribute('style') || '');
      menuToggle.setAttribute('style', 'visibility: hidden;pointer-events: none;');
    }
  });
}

function enableAllMathFieldControls() {
  const mathFields = document.querySelectorAll('math-field');
  mathFields.forEach((field: any) => {
    // Restore virtual keyboard toggle
    const keyboardToggle = field.shadowRoot?.querySelector('[part="virtual-keyboard-toggle"]') as HTMLElement;
    if (keyboardToggle) {
      const originalStyle = keyboardToggle.getAttribute('data-original-style') || '';
      keyboardToggle.setAttribute('style', originalStyle);
      keyboardToggle.removeAttribute('data-original-style');
    }
    
    // Restore menu toggle
    const menuToggle = field.shadowRoot?.querySelector('[part="menu-toggle"]') as HTMLElement;
    if (menuToggle) {
      const originalStyle = menuToggle.getAttribute('data-original-style') || '';
      menuToggle.setAttribute('style', originalStyle);
      menuToggle.removeAttribute('data-original-style');
    }
  });
}

export function updateMathFieldKeyboard(opts?: MathfieldKeyboardOptions) {
  // THe observer here is disbabled because we are currently utilising the event handling the opening and closing of the keuboard.
  // if that is removes, this observer can be used to patch the keycap registry. Please preserve the commented lines.

  //const observer = new MutationObserver(() => {
  const registry = (window as any).mathVirtualKeyboard?.keycapRegistry;
  // For some reason, afterViewInit is called twice simultaneously before the first call disconnects the observer, the second call is
  //  already executed
  const alreadyPatched = Object.values(registry || {}).some(
    (entry: any) => entry.latex === '\\times'
  );
  // if(alreadyPatched){
  //   return;
  //   // observer.disconnect();
  // }
  if (registry && Object.keys(registry).length > 0 && !alreadyPatched) {
    for (const key in registry) {
      const entry = registry[key];
      if (entry.label === '&times;') {
        entry.latex = '\\times';
        entry.variants = [...(entry.variants || []), '\\times'];
        break;
      }
    }
  }
  // });
  //   observer.observe(document.body, {
  //   childList: true,
  //   subtree: true,
  // });

  // Add close button to the virtual keyboard
  // console.log("ENTERING CLOSE BUTTON METHOD")
  addCloseButtonToKeyboard(opts);
}

function restoreHeight(opts: MathfieldKeyboardOptions) {
  const sel = opts.pageContainerSelector || '.page-container';
  const pageContainer = document.querySelector(sel) as HTMLElement;

  if (pageContainer) {
    const previousHeight = opts.pageOriginalHeight;
    if (previousHeight && previousHeight !== '') {
      pageContainer.style.height = previousHeight;
    } else {
      pageContainer.style.height = '';
    }
  }
}

function addCloseButtonToKeyboard(opts: MathfieldKeyboardOptions) {
  // console.log("ENTERED CLOSE BUTTON METHOD")
  const keyboard = document.querySelector('.ML__keyboard.is-visible>.MLK__backdrop');
  // console.log("HERE 1", keyboard)
  if (!keyboard || keyboard.querySelector('.keyboard-close-btn')) return;
  // console.log("HERE 2")

  const closeButton = document.createElement('button');
  closeButton.className = 'keyboard-close-btn';
  closeButton.innerHTML = '×';
  closeButton.style.cssText = `
      position: absolute;
      top: 0px;
      right: 0px;
      width: 50px;
      height: 30px;
      background: red;
      color: white;
      border: none;
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 20% 100%);
      font-size: 18px;
      font-weight: bold;
      cursor: pointer !important;
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: auto;
    `;

  closeButton.addEventListener('click', () => {
    const mathField = document.querySelector('math-field:focus') || document.querySelector('math-field');
    //if (mathField) {
      closeVirtualKeyboard(opts);
    //}
  });

  keyboard.appendChild(closeButton);
  // console.log("FINISHED ADDING CLOSE BUTTON")
}

export function cleanupMathfieldKeyboard() {
  globalKeyboardState.isOpen = false;
  globalKeyboardState.currentMathField = null;
  enableAllMathFieldControls();
  
  // Remove any existing close buttons
  // const closeButtons = document.querySelectorAll('.keyboard-close-btn');
  // closeButtons.forEach(button => button.remove());
}